import type { useLanguage } from "@/context/language"
import type { CoworkWorkspaceAgent } from "@/cowork/api"
import { coworkAgentRegistry } from "./report-template-registry.generated"

export type CoworkAgentTemplate = (typeof coworkAgentTemplates)[number]

export const coworkAgentTemplates = [
  { id: "dashboard", nameKey: "dashboard.title", descriptionKey: "dashboard.agentDescription" },
  {
    id: "custom-report",
    nameKey: "cowork.agents.template.customReport",
    descriptionKey: "cowork.agents.template.customReport.description",
  },
  {
    id: "accounting",
    nameKey: "cowork.agents.template.accounting",
    descriptionKey: "cowork.agents.template.accounting.description",
  },
] as const

export function hasWorkspaceAgentTemplate(
  agents: Pick<CoworkWorkspaceAgent, "template_id">[],
  templateID: string,
) {
  return agents.some((agent) => agent.template_id === templateID)
}

export function workspaceAgentFromTemplate(template: CoworkAgentTemplate, language: ReturnType<typeof useLanguage>) {
  return {
    name: language.t(template.nameKey),
    purpose: language.t(template.descriptionKey),
    mode: "primary" as const,
    status: "active" as const,
    template_id: template.id,
    tools: { ...coworkAgentRegistry[template.id].tools },
    integrations: [],
    permissions: { ...coworkAgentRegistry[template.id].permissions },
  }
}
